export const maintenanceWorkflowsTableColumns = [
  { value: 'status', label: 'Status' },
  { value: 'observations', label: 'Descrição' },
  { value: 'equipment', label: 'Equipamento' },
  { value: 'branch', label: 'Filial' },
  { value: 'creator', label: 'Autor' },
  { value: 'actions', label: 'Ações', className: 'w-11' },
];
